import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointDocumentVerificationData,
  type EnrollmentJointDocumentVerificationSubmitOutput,
} from '../../../../../models/enrollment/joint/document-verification'
import { DocumentVerificationStatus } from '../../../../../models/enrollment/enrollment'

export const getEnrollmentJointDocumentVerificationDataMock: EnrollmentJointDocumentVerificationData = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/document-verification',
    progress: 20,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
  },
}

export const submitEnrollmentJointDocumentVerificationDataMock: EnrollmentJointDocumentVerificationSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/next-page-here',
  },
}

let callCount = 0

export const submitEnrollmentJointDocVerificationCheckStatusDataMock = () => {
  callCount++

  return {
    activePerson: {
      applicationId: '123',
      documentVerificationStatus:
        callCount >= 3 ? DocumentVerificationStatus.Complete : DocumentVerificationStatus.Pending,
      documentVerificationUrl: 'https://example.com',
      path: '/enrollment/hycs/document-verification-complete',
    },
    errors: [],
    isError: false,
  }
}

export const mockGetEnrollmentJointDocumentVerificationData = graphql.mutation(
  'getEnrollmentJointDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentJointDocumentVerificationData = graphql.mutation(
  'submitEnrollmentJointDocumentVerificationData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointDocumentVerificationDataMock } })
  },
)

export const mockSubmitEnrollmentJointDocVerificationCheckStatusData = graphql.mutation(
  'submitEnrollmentJointDocVerificationCheckStatusData',
  () => {
    return HttpResponse.json({
      data: { submitJointEnrollment: submitEnrollmentJointDocVerificationCheckStatusDataMock() },
    })
  },
)

export const mockEnrollmentJointDocumentVerification = [
  mockGetEnrollmentJointDocumentVerificationData,
  mockSubmitEnrollmentJointDocumentVerificationData,
  mockSubmitEnrollmentJointDocVerificationCheckStatusData,
]
